import axios from 'axios';

import type {
  IUserSaveUserDefaultContactBody,
  IUserSaveUserDefaultContactParams,
  IUserSaveUserDefaultContactRequest,
  IUserSaveUserDefaultContactResponse,
} from '@/app-package';

const saveUserDefaultContact = async (
  params: IUserSaveUserDefaultContactParams,
  body: IUserSaveUserDefaultContactBody,
) => {
  const config: IUserSaveUserDefaultContactRequest = {
    url: `/user/default/contact/${params.userId}/${body.rep}`,
    method: 'post',
    data: body,
  };

  const { data } =
    await axios.request<IUserSaveUserDefaultContactResponse>(config);

  return data;
};

export default saveUserDefaultContact;
